package com.example.mystybag.sharedmodels.common.responseModels

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import kotlinx.serialization.Serializable
import kotlin.jvm.JvmField

@Serializable
class UploadFileResponseModel(
    @JvmField
    var url: String = ""
) : BaseResponseModel()
